module.exports = __webpack_public_path__ + "static/img/p2.a994cfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p2.png
// module id = 243
// module chunks = 1